import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { DateFormats } from 'infrastructure/enums';
import { languagesMap } from 'constants/languages';

import styles from './styles.module.scss';

import type { IKeyNoteDrawerHeaderProps } from './types';

const { Text } = Typography;

export const KeyNoteDrawerHeader = ({
  patientName,
  birthDate,
  language,
  doctorName,
  onClose,
}: IKeyNoteDrawerHeaderProps) => {
  const { t } = useTranslation();

  const formattedBirthDate = (() => {
    if (!birthDate) return '';
    const parsed = dayjs(birthDate);
    return parsed.isValid() ? parsed.format(DateFormats['MM/DD/YYYY']) : '';
  })();

  const languageDisplay = languagesMap[language] || language;

  const Separator = () => <Text className={styles['header-separator']}>|</Text>;

  return (
    <Flex
      justify="space-between"
      align="center"
      className={styles['header-section']}
    >
      <Flex vertical align="left">
        <Text className={styles['header-title']}>
          {t('labels.keyNote', 'Key Note')}
        </Text>
        <Flex gap={12} align="center" wrap="wrap">
          <Flex align="center" gap={4}>
            <UserOutlined className={styles['header-user-icon']} />
            <Text className={styles['header-patient-name']}>{patientName}</Text>
          </Flex>
          <Flex align="center" gap={4}>
            {formattedBirthDate && (
              <>
                <Text className={styles['header-secondary-text']}>
                  {formattedBirthDate}
                </Text>
              </>
            )}
            {languageDisplay && (
              <>
                <Separator />
                <Text className={styles['header-secondary-text']}>
                  {languageDisplay}
                </Text>
              </>
            )}
            {doctorName && (
              <>
                <Separator />
                <Text className={styles['header-secondary-text']}>
                  {doctorName}
                </Text>
              </>
            )}
          </Flex>
        </Flex>
      </Flex>
      <Button
        type="text"
        icon={<CloseOutlined className={styles['header-close-icon']} />}
        onClick={onClose}
      />
    </Flex>
  );
};
